import { Card, Typography, CardContent, Stack, Tooltip } from '@mui/material';

import React from 'react';

import { ReactComponent as HighPriorityStatusIcon } from 'common/assets/images/dialHigh.svg';
import { ReactComponent as LowPriorityStatusIcon } from 'common/assets/images/dialLow.svg';
import { ReactComponent as MediumPriorityStatusIcon } from 'common/assets/images/dialMedium.svg';
import { ReactComponent as WorkflowIcon } from 'common/assets/images/workflow-dashboard-icon.svg';
import ChipComponent from 'common/components/Chip/Chip';
import {
	truncateString,
	dateFullYearFormat,
	pascalFormat,
	toSentenceCase,
} from 'common/utils/utilFunctions';

import styles from './TasksCard.module.scss';

interface ITasksCardProps {
	cardKey: any;
	data: any;
	navigateToPath: (data: any) => void;
}
const TasksCard = (props: ITasksCardProps) => {
	const { cardKey, data, navigateToPath } = props;
	const getStatusColor = (color: string) => {
		const colorId = color ? color.toLowerCase() : '';
		let appliedColor = '';
		switch (colorId) {
			case 'high':
				appliedColor = styles['tasks-card-status-high'];
				return appliedColor;
			case 'low':
				appliedColor = styles['tasks-card-status-low'];
				return appliedColor;
			case 'medium':
				appliedColor = styles['tasks-card-status-medium'];
				return appliedColor;
			default:
				return '';
		}
	};

	const getStatusIcon = (color: string) => {
		const colorId = color ? color.toLowerCase() : '';
		let imgElement: any;
		switch (colorId) {
			case 'high':
				imgElement = <HighPriorityStatusIcon fill="white" />;

				return imgElement;
			case 'low':
				imgElement = <LowPriorityStatusIcon fill="white" />;

				return imgElement;
			case 'medium':
				imgElement = <MediumPriorityStatusIcon fill="white" />;

				return imgElement;
			default:
				return '';
		}
	};

	return (
		<Card
			key={cardKey}
			className={styles['tasks-card-container']}
			onClick={() => {
				navigateToPath(data);
			}}
			data-testid="tasks-card-container"
		>
			<CardContent
				className={styles['tasks-card-content']}
				data-testid="tasks-card-content"
			>
				<div>
					<Typography
						className={styles['tasks-card-module-title']}
						mt={1}
						mb={2}
					>
						{data && pascalFormat(data?.assignedObjectType)}
					</Typography>
					<Typography mb={2}>
						<Tooltip
							title={data?.taskName}
							className={styles['tool-tip-menu-item']}
							data-test-id="tool-tip"
						>
							<span className={styles['tasks-card-task-name']}>
								{data?.taskName?.length > 20
									? `${truncateString(data?.taskName, 20)}...`
									: data?.taskName}
							</span>
						</Tooltip>
					</Typography>

					<Stack direction="row" justifyContent="space-between" mb={2}>
						<ChipComponent
							label={data?.type}
							defaultClass
							className={styles['tasks-card-workflow-background']}
							chipIcon={<WorkflowIcon />}
						/>
						{data?.priorityLevel !== null && (
							<ChipComponent
								label={`${pascalFormat(data?.priorityLevel)} priority`}
								defaultClass
								className={getStatusColor(data?.priorityLevel)}
								chipIcon={getStatusIcon(data?.priorityLevel)}
							/>
						)}
					</Stack>
					<div className={styles['tasks-card-duedate-container']}>
						<ChipComponent
							label={data?.status}
							defaultClass
							className={styles['tasks-card-background-type']}
						/>

						<Typography mb={2} className={styles['tasks-card-task-duedate']}>
							{toSentenceCase('Due Date')}:&nbsp;
							{dateFullYearFormat(data?.dueDate)}
						</Typography>
					</div>
				</div>
			</CardContent>
		</Card>
	);
};

export default TasksCard;
